export default __webpack_public_path__ + "static/media/editorial.a5826433.svg";